import { render, staticRenderFns } from "./SendMessageApprovalModal.vue?vue&type=template&id=0ddb1f23&scoped=true&lang=pug"
import script from "./SendMessageApprovalModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageApprovalModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageApprovalModal.vue?vue&type=style&index=0&id=0ddb1f23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddb1f23",
  null
  
)

export default component.exports